import { DOCUMENT } from '@angular/common';
import { Directive, Host, Inject, Input, Self } from '@angular/core';

import { RtTextInput } from '@recruitee/user-interface';

import { PlaceholderConfigMap } from './placeholder';

@Directive({
  selector: '[insertPlaceholderInput]',
  exportAs: 'placeholderInput',
})
export class InsertPlaceholderInputDirective {
  @Input() public placeholdersConfig: PlaceholderConfigMap = {};

  constructor(@Host() @Self() public input: RtTextInput, @Inject(DOCUMENT) private doc: Document) {}

  public insert(text: string): void {
    this.input.insertAtCaret(text, 'placeholder');
  }
}
